const VISITOR_ID_KEY = 'zalena_visitor_id';
const CONVERSATION_KEY_PREFIX = 'zalena_conv';
const TWENTY_FOUR_HOURS_MS = 24 * 60 * 60 * 1000;
export function getOrCreateVisitorId() {
    try {
        let id = localStorage.getItem(VISITOR_ID_KEY);
        if (!id) {
            id = `visitor_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
            localStorage.setItem(VISITOR_ID_KEY, id);
        }
        return id;
    }
    catch (_a) {
        // localStorage unavailable (incognito, full, etc.)
        return `visitor_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    }
}
function getConvKey(widgetId) {
    return `${CONVERSATION_KEY_PREFIX}_${widgetId || 'default'}`;
}
export function loadConversationRef(widgetId) {
    try {
        const raw = localStorage.getItem(getConvKey(widgetId));
        if (!raw)
            return null;
        const ref = JSON.parse(raw);
        if (Date.now() - ref.lastActivity > TWENTY_FOUR_HOURS_MS) {
            clearConversationRef(widgetId);
            return null;
        }
        return ref;
    }
    catch (_a) {
        return null;
    }
}
export function saveConversationRef(ref, widgetId) {
    try {
        localStorage.setItem(getConvKey(widgetId), JSON.stringify(ref));
    }
    catch (_a) {
        // localStorage full or unavailable
    }
}
export function clearConversationRef(widgetId) {
    try {
        localStorage.removeItem(getConvKey(widgetId));
    }
    catch (_a) {
        // ignore
    }
}
